import type { DisplayTypeV5 } from '@seek/chalice-types';

import type { ResultsState } from './types';

export const getRoleIdFromResults = (results: ResultsState) => {
  const roleIds = results?.results?.jobs
    ?.map((job) => !job.isFeatured && job.roleId)
    .filter((id) => id);

  return roleIds?.[0] || undefined;
};

export const getIsFeatured = ({
  displayType,
  isFeatured,
}: {
  displayType: DisplayTypeV5;
  isFeatured?: boolean | null;
}) => {
  if (typeof isFeatured === 'boolean') {
    return isFeatured;
  }
  return displayType === 'promoted';
};
